<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('projectProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('projectProfile.pageTitle'),
            href: '/admin/project-profiles'
          },
          {
            text: $t('view'),
            active: true
          }
        ]"
      />
    </div>
    <ts-loading-banner :loading="loading">
      <ts-card>
        <ts-card-wrapper>
          <div class="ts-flex ts-items-center ts-space-x-3">
            <div
              class="ts-w-12 ts-h-12 ts-bg-gray-200 ts-rounded-full ts-p-2 ts-flex ts-items-center ts-justify-center"
            >
              <button
                @click.prevent="$router.go(-1)"
                class=" ts-w-6 ts-h-6 ts-bg-red-600 ts-rounded-full ts-flex ts-items-center ts-justify-center focus:ts-outline-none"
              >
                <Icon
                  type="md-arrow-round-back"
                  class="ts-text-white"
                  size="20"
                />
              </button>
            </div>

            <div>
              <h1
                class="ts-font-roboto-koulen ts-text-2xl ts-text-gray-900 ts-mb-0"
              >
                {{ resources ? resources.milestone_name : '' }}
                <a href="#" @click.prevent="onEdit"
                  ><Icon type="ios-create-outline"
                /></a>
              </h1>
              <div>
                <span class="ts-mb-0">
                  <Icon type="ios-contact-outline" size="15" />
                  {{ resources.owner_name_en }}
                </span>
                <span class="ts-mb-0">
                  <Icon type="md-pricetag" size="15" />
                  {{ $t('projectProfile.milestone') }}
                </span>
              </div>
            </div>

            <!-- <h1 class="ts-uppercase ts-font-robot ts-text-2xl ts-mb-0">
              {{ $t('projectProfile.milestone') }}
            </h1> -->
          </div>
          <div class="ts-bg-white ts-p-4 ts-rounded-md">
            <Tabs @on-click="onTabChange">
              <TabPane label="Detail" icon="ios-book" name="detail">
                <ViewDetail :resources="resources" @fetch="fetchResource" />
              </TabPane>
              <TabPane label="Task" icon="ios-menu" name="task">
                <TaskProfile v-if="active_tab == 'task'" />
              </TabPane>
              <TabPane label="History" icon="ios-clock" name="history">
                <HistoryTab v-if="active_tab == 'history'" />
              </TabPane>
            </Tabs>
          </div>
        </ts-card-wrapper>
      </ts-card>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ViewDetail from './components/view-detail.vue'
import TaskProfile from './components/task-profile.vue'
import HistoryTab from './components/history-tab.vue'
export default {
  components: {
    ViewDetail,
    TaskProfile,
    HistoryTab
  },
  data() {
    return {
      loading: false,
      active_tab: undefined,
      resources: []
    }
  },
  created() {
    this.fetchResource()
  },
  methods: {
    ...mapActions('projectMgt/projectMilestone', ['find']),
    fetchResource() {
      this.loading = true
      this.find(this.$route.params.milestone_id)
        .then(response => {
          this.resources = response.data
        })
        .finally(() => (this.loading = false))
    },
    onTabChange(name) {
      this.active_tab = name
    }
  }
}
</script>
